import styled from '@emotion/styled'
import { Box, TableContainer, TableHead } from '@mui/material'

export const Wrapper = styled(Box)(`
	width: 100%;
	border: 1px #D8D8D6 solid;
	border-radius: 4px;
	margin-top:15px;
	
	& > div { border-radius: 4px; }
	& tr { border-bottom: 2px #D8D8D6 solid; }
	& tr td, & tr th { padding: 0 12px; line-height: 35px; height: 35px;  }
	& tr th { text-transform: none !important; 
		font-weight: 600 !important;
	}
	& tr td { 
		font-size: 13px; 
		font-weight: 400;
	}
	& thead { background-color: #fff; border-bottom: 2px #D8D8D6 solid;}
`)

export const ProgressBarWrapper = styled(Box)(`
	width: 100%;
	display: flex;
	align-items: center;
	& span { border-radius: 4px; }
`)

export const StyledTableContainer = styled(TableContainer)({
  maxHeight: '450px',
  overflowY: 'auto',
})

export const StyledTableHead = styled(TableHead)(`
	position: sticky;
	top: 0;
	background-color: #fff;
	z-index: 10;
`)

export const NoDataFound = styled(Box)(`
	padding-bottom: 15px;
	& * { line-height: 1; }
`)
